export enum FooterSections {
    PAYMENTS = 'payments',
    LICENCES = 'licences',
    GAMEVENDORS = 'game_vendors',
    LINKS = 'links',
    ICONS = 'icons',
}
